export enum NominationStatus {
  REQUESTED_ANOTHER = -3,
  NOT_REQUESTED = -2,
  CANCELLED = -1,
  PENDING,
  REJECTED,
  ACCEPTED,
}
